import "./App.css"
import "bootstrap/dist/css/bootstrap.min.css"

export default function Header() {
  return (
    <div>
      <div className="bg-secondary p-4 text-white display-4 nav-font">Get It Done!</div>
    </div>
  )
}
